{
  "name": "react-spread-sheet-excel",
  "version": "3.4.3",
  "description": "Lightning-fast React spreadsheet component with Excel-like features. Render 100,000+ cells with formulas, formatting, copy/paste, undo/redo. Perfect for data grids and Excel-like apps.",
  "keywords": [
    "react-spread-sheet-excel",
    "react-excel",
    "react-excel-component",
    "excel-like-spreadsheet",
    "spreadsheet-excel",
    "react-datagrid",
    "data-grid",
    "editable-table",
    "virtual-scroll",
    "formula-calculation",
    "cell-formatting",
    "csv-export",
    "xlsx-import-export",
    "typescript-spreadsheet",
    "excel-component",
    "data-entry-grid",
    "copy-paste-cells",
    "undo-redo",
    "merge-cells",
    "lightweight-excel",
    "performance-spreadsheet",
    "fast-rendering",
    "100000-cells",
    "react-grid-editor",
    "json-spreadsheet"
  ],
  "author": "Sojin Antony",
  "dependencies": {
    "gh-pages": "^6.3.0",
    "react-intersection-observer": "^11.0.0"
  },
  "type": "module",
  "main": "build/index.js",
  "module": "build/index.js",
  "files": [
    "build",
    "README.md",
    "PERFORMANCE.md"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/sojinantony01/react-spread-sheet.git"
  },
  "peerDependencies": {
    "react": ">=18.2.0",
    "react-dom": ">=18.2.0"
  },
  "devDependencies": {
    "@e965/xlsx": "^0.20.3",
    "@rollup/plugin-commonjs": "^29.0.0",
    "@rollup/plugin-node-resolve": "^16.0.3",
    "@rollup/plugin-typescript": "^12.3.0",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.1",
    "@testing-library/user-event": "^14.6.1",
    "@types/node": "^22.0.0",
    "@types/react": "^18.3.31",
    "@types/react-dom": "^18.3.7",
    "@vitejs/plugin-react": "^6.0.5",
    "@vitest/coverage-v8": "^4.0.18",
    "esbuild": "^0.28.1",
    "jsdom": "^27.4.0",
    "postcss": "^8.4.16",
    "prettier": "^3.4.2",
    "rollup": "^4.54.0",
    "rollup-plugin-peer-deps-external": "^2.2.4",
    "rollup-plugin-postcss": "^4.0.2",
    "rollup-plugin-typescript2": "^0.36.0",
    "tslib": "^2.8.1",
    "typescript": "^5.9.3",
    "vite": "^8.2.1",
    "vitest": "^4.0.16"
  },
  "scripts": {
    "dev": "vite",
    "build": "rm -rf build && rollup -c",
    "demo:build": "vite build",
    "demo:preview": "vite preview",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:ci": "vitest run --coverage",
    "deploy": "npm run demo:build && gh-pages -d dist",
    "prepublishOnly": "npm run build",
    "format": "npx prettier --write './**/*.{ts,tsx,css,json,scss}' --config ./.prettierrc.json",
    "format-check": "npx prettier --check './**/*.{ts,tsx,css,json,scss}' --config ./.prettierrc.json"
  },
  "homepage": "https://sojinantony01.github.io/react-spread-sheet",
  "license": "ISC"
}
